import { Periods } from '@shared/utils/History/TFInfo';
import { HistoryMergerBasedByDay } from './HistoryMergerBasedByDay';
export class HistoryMergerYear extends HistoryMergerBasedByDay {
    constructor(inputParams) {
        super(inputParams);
    }
    GetDaysInPeriod(dateTime) {
        let result = 0;
        let currentDate = dateTime;
        for (let year = dateTime.year; year < dateTime.year + this.GetCount(); year++) {
            const isLeapYear = currentDate.isInLeapYear;
            result += isLeapYear ? 366 : 365;
            currentDate = currentDate.plus({ years: 1 });
        }
        return result;
    }
    IsStartPeriodDate(dateTime) {
        const january = 1;
        return dateTime.month === january && dateTime.day === 1;
    }
    GetBasePeriod() {
        return Periods.YEAR;
    }
}
